<template>
  <div class='our-products-section-wrapper'>
    <div class="container">
      <h2 class='our-products-title h2-title'>
        <span>Наші моделі</span>
      </h2>
      <div class='our-products-text paragraph-s'>
        Ми пропонуємо великий вибір моделей з різних тканин та широкою палітрою кольорів.
        Наша продукція виготовляється з натуральних тканин високої зносостійкості з урахуванням усіх вимог ДСТУ.
      </div>
      <div class='our-products-wrapper mb-l' v-if="productCategories">
        <div class="product-category-item" v-for='item of productCategories' :key="item.id" @click="redirectToProducts(item.id)">
          <div class="category-image-wraper mb-s">
            <app-image
              :width="213"
              :height="320"
              :lazy-src="item.preview"
              :alt='item.name'
            />
            <div class='hidden-show-more fw-bold'>
              <button class='app-btn app-btn-primary app-btn-small c-p'>
                Показати більше
              </button>
            </div>
          </div>
          <div class='h4-title product-category-item-text'>
            {{item.name}}
          </div>
        </div>
      </div>
      <div class='show-all-products-button'>
        <button class='app-btn app-btn-primary outline' @click="redirectToProducts('all')">Переглянути всі товари</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import router from '@/router.js'
import AppImage from '@/components/common/AppImage.vue'
export default {
  name: 'OurProductsSection',
  computed: {
    ...mapState([
      'productCategories'
    ])
  },
  components: {
    AppImage
  },
  methods: {
    redirectToProducts (sortBy) {
      if (sortBy !== 'all') {
        router.push({ name: 'products', params: { cat_id: sortBy } })
      } else {
        router.push({ name: 'products' })
      }
    }
  },
  mounted () {
    if (this.productCategories.length === 0) {
      this.$store.dispatch('loadProductCategories')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors.scss';
@import 'src/styles/_sizes.scss';

.our-products-section-wrapper {
  background: $white-color;
  padding: 100px 0px;
  border-bottom: 1px solid $border-color;
  .our-products-title {
    margin-bottom: 20px;
  }
  .our-products-text {
    margin-bottom: 45px;
  }
  .our-products-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    justify-content: center;
    .product-category-item {
      display: flex;
      flex-direction: column;
      padding: 10px;
      width: 213px;
      text-align: center;
      cursor: pointer;
      .category-image-wraper {
        position: relative;
        display: flex;
        overflow: hidden;
        z-index: 100;
        .hidden-show-more {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: $half-asset-color;
          color: $white-color;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: all 0.25s ease-in-out;
        }
      }
      .product-category-item-text {
        transition: all 0.25s ease-in-out;
      }
      &:hover .product-category-item-text {
        color: $primary-color;
      }
      &:hover .hidden-show-more  {
        opacity: 1;
      }
    }
  }
  .show-all-products-button {
    display: flex;
    justify-content: center;
  }
}

@media (max-width: $desktop){
  .our-products-section-wrapper {
    padding: 50px 0px;
    .our-products-wrapper {
      justify-content: center;
    }
  }
}
@media (max-width: $tablet){
  .our-products-section-wrapper {
    padding: 50px 0px;
    .our-products-wrapper {
      .product-category-item {
        .category-image-wraper {
          .hidden-show-more {
            display: none;
            transition: none;
          }
        }
        &:hover .hidden-show-more  {
          display: none;
        }
      }
    }
  }
}
@media (max-width: $mobile){
  .our-products-section-wrapper {
    padding: 50px 0px;
    .our-products-wrapper {
      justify-content: center;
      .product-category-item {
        .category-image-wraper {
          .hidden-show-more {
            display: none;
            transition: none;
          }
        }
        &:hover .hidden-show-more  {
          display: none;
        }
      }
    }
  }
}
</style>
